import React from 'react';
import { useTheme, themeLabel } from '../hooks/useTheme';
import styles from './Layout.module.css';

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </svg>
  );
}

function MonitorIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </svg>
  );
}

const ICONS = {
  light: <SunIcon />,
  dark: <MoonIcon />,
  auto: <MonitorIcon />,
};

export default function ThemeToggle() {
  const { mode, cycle } = useTheme();
  return (
    <button
      type="button"
      className={styles.themeBtn}
      onClick={cycle}
      title={`Theme: ${themeLabel(mode)}`}
      aria-label={`Theme is ${themeLabel(mode)}, click to cycle`}
    >
      {ICONS[mode]}
      <span className={styles.themeLabel}>{themeLabel(mode)}</span>
    </button>
  );
}
